import mapMarker from "../../assets/images/map/map-marker.png";

export interface CustomMapMarkerOptions {
  /** 여러 마커가 동시에 생길 때 순차적으로 살짝 딜레이(ms 단위 누적, 상한 적용) */
  staggerIndex?: number;
}

const STAGGER_STEP_MS = 26;
const STAGGER_MAX_MS = 380;

/**
 * 네이버 지도 Marker `icon.content`용 HTML 문자열.
 * Tailwind 클래스는 지도 오버레이 DOM에서 처리되지 않을 수 있어 인라인·전역 클래스 사용.
 */
const CustomMapMarker = (options?: CustomMapMarkerOptions): string => {
  const staggerIndex = options?.staggerIndex ?? 0;
  const delayMs = Math.min(staggerIndex * STAGGER_STEP_MS, STAGGER_MAX_MS);

  const markerContentArray = [
    `<div class="map-marker-pin-enter" style="animation-delay:${delayMs}ms">`,
    '<div style="width:36px;height:36px;position:relative;">',
    `<img src="${mapMarker}" width="36" height="36" alt="" draggable="false" style="display:block;" />`,
    "</div>",
    "</div>",
  ];

  return markerContentArray.join("");
};

export default CustomMapMarker;
